import React from 'react';

// service_pr4mzuh
// template_3eq992a
// gylnWLT4ZM7jiCre7


import Header from './components/header/Header';
// import Banner from './components/banner/Banner';
import Banner2 from './components/banner2/Banner2';
import CansContainer from './components/cans-container/CansContainer';
import Benefits from './components/benefits/Benefits';
import VideoPlayer from './components/video-player/VideoPlayer';
import StripeLeft from './components/stripe/StripeLeft';
import StripeRight from './components/stripe/StripeRight';
import Animation from './components/animation/Animation';
import FaqParent from './components/faq-parent/FaqParent';
import Contact from './components/contact/Contact';
import Updates from './components/updates/Updates';
import Footer from './components/footer/Footer';

const App = () => {
const flavors1 = [
    { text: "Refreshing Taste", color: "#0598F8", bgColor: "#0598F81A" },
    { text: "Real fruit blend", color: "#fff", bgColor: "#EA7D1A" },
    { text: "Naturally Flavored", color: "#089556", bgColor: "#0895561A" },
    { text: "Smooth & Delicious", color: "#703326", bgColor: "#FFE2D0" },
    { text: "Tropical Fruit Mix", color: "#fff", bgColor: "#DC2D53" },
    { text: "Burst of Freshness", color: "#660E9B", bgColor: "#A954DD17" },
    { text: "Refreshing Taste", color: "#0598F8", bgColor: "#0598F81A" },
    { text: "Real fruit blend", color: "#fff", bgColor: "#EA7D1A" },
    { text: "Naturally Flavored", color: "#089556", bgColor: "#0895561A" },
    { text: "Smooth & Delicious", color: "#703326", bgColor: "#FFE2D0" },
    { text: "Tropical Fruit Mix", color: "#fff", bgColor: "#DC2D53" },
    { text: "Burst of Freshness", color: "#660E9B", bgColor: "#A954DD17" },
    { text: "Refreshing Taste", color: "#0598F8", bgColor: "#0598F81A" },
    { text: "Real fruit blend", color: "#fff", bgColor: "#EA7D1A" },
    { text: "Naturally Flavored", color: "#089556", bgColor: "#0895561A" },
    { text: "Smooth & Delicious", color: "#703326", bgColor: "#FFE2D0" },
    { text: "Tropical Fruit Mix", color: "#fff", bgColor: "#DC2D53" },
    { text: "Burst of Freshness", color: "#660E9B", bgColor: "#A954DD17" },
  ];
const flavors2 = [
    { text: "Refreshing Taste", color: "#0598F8", bgColor: "#0598F81A" },
    { text: "Real fruit blend", color: "#fff", bgColor: "#EA7D1A" },
    { text: "Naturally Flavored", color: "#089556", bgColor: "#0895561A" },
    { text: "Smooth & Delicious", color: "#703326", bgColor: "#FFE2D0" },
    { text: "Tropical Fruit Mix", color: "#fff", bgColor: "#DC2D53" },
    { text: "Burst of Freshness", color: "#660E9B", bgColor: "#A954DD17" },
    { text: "Refreshing Taste", color: "#0598F8", bgColor: "#0598F81A" },
    { text: "Real fruit blend", color: "#fff", bgColor: "#EA7D1A" },
    { text: "Naturally Flavored", color: "#089556", bgColor: "#0895561A" },
    { text: "Smooth & Delicious", color: "#703326", bgColor: "#FFE2D0" },
    { text: "Tropical Fruit Mix", color: "#fff", bgColor: "#DC2D53" },
    { text: "Burst of Freshness", color: "#660E9B", bgColor: "#A954DD17" },
    { text: "Refreshing Taste", color: "#0598F8", bgColor: "#0598F81A" },
    { text: "Real fruit blend", color: "#fff", bgColor: "#EA7D1A" },
    { text: "Naturally Flavored", color: "#089556", bgColor: "#0895561A" },
    { text: "Smooth & Delicious", color: "#703326", bgColor: "#FFE2D0" },
    { text: "Tropical Fruit Mix", color: "#fff", bgColor: "#DC2D53" },
    { text: "Burst of Freshness", color: "#660E9B", bgColor: "#A954DD17" },
  ];


  return (
    <div>
      <Header />
      <Banner2 />
      <CansContainer />
      <Benefits />
      <VideoPlayer />
      <div style={{paddingBottom: "5rem", background: "#FFFDF8"}}></div>
      <StripeLeft items={flavors1} />
      <StripeRight items={flavors2} />
       <Animation />
      <FaqParent />
      <Contact />
      <Updates />
      <Footer />
    </div>
  )
}

export default App;